export class OptionPathToUrlMapper {
    static getOverridesValues() {
        return Object.values(OptionPathToUrlMapper.optionPathOverrides);
    }
    static hasOverride(optionPath) {
        return OptionPathToUrlMapper.optionPathOverrides[optionPath] !== undefined;
    }
    static getOverrideValueKey(value) {
        return Object.keys(OptionPathToUrlMapper.optionPathOverrides)
            .find(key => OptionPathToUrlMapper.optionPathOverrides[key] === value);
    }
    static mapToUrlPath(optionPath) {
        if (OptionPathToUrlMapper.optionPathOverrides[optionPath]) {
            return OptionPathToUrlMapper.optionPathOverrides[optionPath];
        }
        return optionPath;
    }
    static mapToCanonicalUrlPath(optionPath) {
        if (OptionPathToUrlMapper.canonicalSlugExceptions.has(optionPath)) {
            return optionPath;
        }
        return optionPath.split("-").map(it => {
            if (OptionPathToUrlMapper.canonicalUrlMapping[it]) {
                return OptionPathToUrlMapper.canonicalUrlMapping[it];
            }
            return it;
        }).join("-");
    }
}
OptionPathToUrlMapper.optionPathOverrides = {
    'compress-audio': 'audio-compressor',
    'compress-image': 'image-compressor',
    'compress-video': 'video-compressor',
    'convert-audio': 'audio-converter',
    'convert-image': 'image-converter',
    'convert-video': 'video-converter',
    // Per-format hubs (convert-{ext}-to-{mediatype} → /{ext}-converter)
    'convert-mp4-to-video': 'mp4-converter',
    'convert-mov-to-video': 'mov-converter',
    'convert-webm-to-video': 'webm-converter',
    'convert-avi-to-video': 'avi-converter',
    'convert-mkv-to-video': 'mkv-converter',
    'convert-flv-to-video': 'flv-converter',
    'convert-png-to-image': 'png-converter',
    'convert-jpeg-to-image': 'jpeg-converter',
    'convert-jpg-to-image': 'jpg-converter', // canonical twin of jpeg-converter ("jpg converter" demand ~3.4x)
    'convert-webp-to-image': 'webp-converter',
    'convert-heic-to-image': 'heic-converter',
    'convert-gif-to-image': 'gif-converter',
    'convert-apng-to-image': 'apng-converter',
    'convert-svg-to-image': 'svg-converter',
    'convert-mp3-to-audio': 'mp3-converter',
    'convert-wav-to-audio': 'wav-converter',
    'convert-m4a-to-audio': 'm4a-converter',
    'convert-flac-to-audio': 'flac-converter',
    'convert-aac-to-audio': 'aac-converter',
    // --- Phase-2 expansion: 116 file-format hubs (2026-06-19) ---
    'convert-3fr-to-image': '3fr-converter',
    'convert-3g2-to-video': '3g2-converter',
    'convert-3gp-to-video': '3gp-converter',
    'convert-3gpp-to-video': '3gpp-converter',
    'convert-3mf-to-model3d': '3mf-converter',
    'convert-7z-to-archive': '7z-converter',
    'convert-ac3-to-audio': 'ac3-converter',
    'convert-aif-to-audio': 'aif-converter',
    'convert-aifc-to-audio': 'aifc-converter',
    'convert-aiff-to-audio': 'aiff-converter',
    'convert-amr-to-audio': 'amr-converter',
    'convert-arw-to-image': 'arw-converter',
    'convert-asf-to-video': 'asf-converter',
    'convert-ass-to-subtitle': 'ass-converter',
    'convert-au-to-audio': 'au-converter',
    'convert-av1-to-video': 'av1-converter',
    'convert-avchd-to-video': 'avchd-converter',
    'convert-avif-to-image': 'avif-converter',
    'convert-bmp-to-image': 'bmp-converter',
    'convert-caf-to-video': 'caf-converter',
    'convert-cavs-to-video': 'cavs-converter',
    'convert-cr2-to-image': 'cr2-converter',
    'convert-cr3-to-image': 'cr3-converter',
    'convert-crw-to-image': 'crw-converter',
    'convert-csv-to-subtitle': 'csv-converter',
    'convert-dcr-to-image': 'dcr-converter',
    'convert-dfxp-to-subtitle': 'dfxp-converter',
    'convert-divx-to-video': 'divx-converter',
    'convert-dng-to-image': 'dng-converter',
    'convert-doc-to-document': 'doc-converter',
    'convert-docx-to-document': 'docx-converter',
    'convert-dss-to-audio': 'dss-converter',
    'convert-dv-to-video': 'dv-converter',
    'convert-dvr-to-video': 'dvr-converter',
    'convert-eot-to-font': 'eot-converter',
    'convert-eps-to-image': 'eps-converter',
    'convert-epub-to-ebook': 'epub-converter',
    'convert-erf-to-image': 'erf-converter',
    'convert-f4v-to-video': 'f4v-converter',
    'convert-glb-to-model3d': 'glb-converter',
    'convert-gltf-to-model3d': 'gltf-converter',
    'convert-heif-to-image': 'heif-converter',
    'convert-hevc-to-video': 'hevc-converter',
    'convert-ico-to-image': 'ico-converter',
    'convert-jfif-to-image': 'jfif-converter',
    'convert-lrc-to-subtitle': 'lrc-converter',
    'convert-m2ts-to-video': 'm2ts-converter',
    'convert-m2v-to-video': 'm2v-converter',
    'convert-m4b-to-audio': 'm4b-converter',
    'convert-m4r-to-audio': 'm4r-converter', // 2026-10-11 owner decision "Add M4R" (xconfig format-hub-allowlist)
    'convert-m4v-to-video': 'm4v-converter',
    'convert-mjpeg-to-video': 'mjpeg-converter',
    'convert-mobi-to-ebook': 'mobi-converter',
    'convert-mos-to-image': 'mos-converter',
    'convert-mpeg-to-video': 'mpeg-converter',
    'convert-mpeg2-to-video': 'mpeg2-converter',
    'convert-mpg-to-video': 'mpg-converter',
    'convert-mrw-to-image': 'mrw-converter',
    'convert-mts-to-video': 'mts-converter',
    'convert-mxf-to-video': 'mxf-converter',
    'convert-nef-to-image': 'nef-converter',
    'convert-obj-to-model3d': 'obj-converter',
    'convert-odg-to-image': 'odg-converter',
    'convert-odp-to-document': 'odp-converter',
    'convert-ods-to-document': 'ods-converter',
    'convert-odt-to-document': 'odt-converter',
    'convert-oga-to-audio': 'oga-converter',
    'convert-ogg-to-audio': 'ogg-converter',
    'convert-ogv-to-video': 'ogv-converter',
    'convert-opus-to-audio': 'opus-converter',
    'convert-orf-to-image': 'orf-converter',
    'convert-otf-to-font': 'otf-converter',
    'convert-pdf-to-document': 'pdf-converter',
    'convert-pef-to-image': 'pef-converter',
    'convert-ply-to-model3d': 'ply-converter',
    'convert-step-to-model3d': 'step-converter',
    'convert-iges-to-model3d': 'iges-converter',
    'convert-brep-to-model3d': 'brep-converter',
    'convert-3dm-to-model3d': '3dm-converter',
    'convert-ppm-to-image': 'ppm-converter',
    'convert-ps-to-document': 'ps-converter',
    'convert-psd-to-image': 'psd-converter',
    'convert-pub-to-image': 'pub-converter',
    'convert-raf-to-image': 'raf-converter',
    'convert-rar-to-archive': 'rar-converter',
    'convert-rm-to-video': 'rm-converter',
    'convert-rmvb-to-video': 'rmvb-converter',
    'convert-rw2-to-image': 'rw2-converter',
    'convert-sbv-to-subtitle': 'sbv-converter',
    'convert-smi-to-subtitle': 'smi-converter',
    'convert-srt-to-subtitle': 'srt-converter',
    'convert-ssa-to-subtitle': 'ssa-converter',
    'convert-stl-to-subtitle': 'stl-converter',
    'convert-sub-to-subtitle': 'sub-converter',
    'convert-swf-to-video': 'swf-converter',
    'convert-tar-to-archive': 'tar-converter',
    'convert-tar.bz2-to-archive': 'tar.bz2-converter',
    'convert-tar.gz-to-archive': 'tar.gz-converter',
    'convert-tar.xz-to-archive': 'tar.xz-converter',
    'convert-tb2-to-archive': 'tb2-converter',
    'convert-tgz-to-archive': 'tgz-converter',
    'convert-tiff-to-image': 'tiff-converter',
    'convert-ts-to-video': 'ts-converter',
    'convert-ttf-to-font': 'ttf-converter',
    'convert-ttml-to-subtitle': 'ttml-converter',
    'convert-txt-to-subtitle': 'txt-converter',
    'convert-tz2-to-archive': 'tz2-converter',
    'convert-vob-to-video': 'vob-converter',
    'convert-voc-to-audio': 'voc-converter',
    'convert-vtt-to-subtitle': 'vtt-converter',
    'convert-weba-to-audio': 'weba-converter',
    'convert-wma-to-audio': 'wma-converter',
    'convert-wmv-to-video': 'wmv-converter',
    'convert-woff-to-font': 'woff-converter',
    'convert-woff2-to-font': 'woff2-converter',
    'convert-wtv-to-video': 'wtv-converter',
    'convert-x3f-to-image': 'x3f-converter',
    'convert-xcf-to-image': 'xcf-converter',
    'convert-xvid-to-video': 'xvid-converter',
    'convert-zip-to-archive': 'zip-converter',
    'resize-image': 'image-resizer',
    'merge-pdf-to-pdf': 'merge-pdf',
    'cut-video': 'video-cutter',
    'trim-video': 'video-trimmer',
    'cut-audio': 'audio-cutter',
    'trim-audio': 'audio-trimmer',
    'count-word': 'word-counter',
    'encode-url': 'url-encoder',
    'decode-url': 'url-decoder',
    'encode-base64': 'base64-encoder',
    'decode-base64': 'base64-decoder',
    'generate-meme': 'meme-generator',
    // Utility tools
    'generate-hash': 'hash-generator',
    'generate-lorem-ipsum': 'lorem-ipsum-generator',
    'generate-color': 'color-converter',
    'generate-number-base': 'number-base-converter',
    'generate-text-case': 'text-case-converter',
    'convert-image-to-text': 'image-to-text',
    // Phase 2 GENERATE tools
    'generate-qr-code': 'qr-code-generator',
    'generate-password': 'password-generator',
    'generate-uuid': 'uuid-generator',
    'generate-cron': 'cron-generator',
    'generate-text-diff': 'text-diff',
    'generate-chmod': 'chmod-calculator',
    'generate-aspect-ratio': 'aspect-ratio-calculator',
    // Phase 2 FORMAT → *-formatter
    'format-json': 'json-formatter',
    'format-css': 'css-formatter',
    'format-html': 'html-formatter',
    'format-js': 'js-formatter',
    'format-sql': 'sql-formatter',
    // Phase 2 MINIFY → *-minifier
    'minify-json': 'json-minifier',
    'minify-css': 'css-minifier',
    'minify-html': 'html-minifier',
    'minify-js': 'js-minifier',
    // Phase 2 TEST
    'test-regex': 'regex-tester',
    // Phase 2 DECODE/ENCODE
    'decode-jwt': 'jwt-decoder',
    'encode-htmlentity': 'html-entity-encoder',
    'decode-htmlentity': 'html-entity-decoder',
    // S1 family #3 — SEO / web generators (FEATURE_EXPANSION_RESEARCH.md §5.3)
    'generate-favicon': 'favicon-generator',
    'generate-ogimage': 'og-image-generator',
    'generate-twittercard': 'twitter-card-generator',
    'generate-metatag': 'meta-tag-generator',
    'generate-jsonldschema': 'json-ld-schema-generator',
    'generate-sitemap': 'sitemap-generator',
    'generate-robots': 'robots-txt-generator',
    'generate-htaccess': 'htaccess-generator',
    'generate-imagedatauri': 'image-to-base64',
    // S1 family #4 — JSON → type generators (FEATURE_EXPANSION_RESEARCH.md §5.4)
    'convert-json-to-tsinterface': 'convert-json-to-typescript',
    'convert-json-to-gostruct': 'convert-json-to-go',
    'convert-json-to-pythondataclass': 'convert-json-to-python',
    'convert-json-to-ruststruct': 'convert-json-to-rust',
    'convert-json-to-kotlinclass': 'convert-json-to-kotlin',
    'convert-json-to-javapojo': 'convert-json-to-java',
    'convert-json-to-csharpclass': 'convert-json-to-csharp',
    'convert-json-to-jsonschema': 'convert-json-to-jsonschema',
    // S1 family #4 — HTML table converters
    'convert-htmltable-to-markdown': 'convert-html-table-to-markdown',
    'convert-htmltable-to-csv': 'convert-html-table-to-csv',
    'convert-htmltable-to-json': 'convert-html-table-to-json',
    // S1 family #4 — cURL converters
    'convert-curl-to-fetch': 'convert-curl-to-fetch',
    'convert-curl-to-httpie': 'convert-curl-to-httpie',
    'convert-curl-to-python': 'convert-curl-to-python',
    'convert-curl-to-wget': 'convert-curl-to-wget',
    // S1 family #4 — dev format fillers (FORMAT process)
    'format-toml': 'toml-formatter',
    'format-ini': 'ini-formatter',
    'format-properties': 'properties-formatter',
    'format-env': 'env-formatter',
    'format-hcl': 'hcl-formatter',
    'format-graphql': 'graphql-formatter',
    // S1 family #4 — utility generators
    'generate-markdowntoc': 'markdown-toc-generator',
    'generate-slug': 'slug-generator',
    'generate-bignumber': 'big-number-calculator',
    'generate-roman': 'roman-numeral-converter',
    'generate-hexdump': 'hex-dump-viewer',
    // S1 family #4 — lookup tables
    'lookup-httpstatus': 'http-status-codes',
    'lookup-mimetype': 'mime-types',
    'lookup-ascii': 'ascii-table',
    'lookup-unicode': 'unicode-table',
    // S2 family #2 — color extras + CSS generators (FEATURE_EXPANSION_RESEARCH.md §5.2)
    'generate-gradient': 'gradient-generator',
    'generate-palette': 'palette-extractor',
    'generate-contrast': 'contrast-checker',
    'generate-colorblindness': 'color-blindness-simulator',
    'generate-eyedropper': 'eyedropper',
    'generate-pantone': 'pantone-converter',
    'generate-tailwindpalette': 'tailwind-palette-builder',
    'generate-materialpalette': 'material-color-tool',
    'generate-boxshadow': 'box-shadow-generator',
    'generate-clippath': 'clip-path-generator',
    'generate-cssanimation': 'css-animation-generator',
    'generate-cssgrid': 'css-grid-generator',
    'generate-flexbox': 'flexbox-generator',
    'generate-borderradius': 'border-radius-generator',
    'generate-cssfilter': 'css-filter-generator',
    'generate-csstransform': 'css-transform-generator',
    'generate-glassmorphism': 'glassmorphism-generator',
    'generate-neumorphism': 'neumorphism-generator',
    'generate-triangle': 'triangle-generator',
    // S3 family #5 — calculators (FEATURE_EXPANSION_RESEARCH.md §5.5)
    'calculate-bmi': 'bmi-calculator',
    'calculate-bmr': 'bmr-calculator',
    'calculate-tdee': 'tdee-calculator',
    'calculate-bodyfat': 'body-fat-calculator',
    'calculate-calorie': 'calorie-calculator',
    'calculate-duedate': 'due-date-calculator',
    'calculate-percentage': 'percentage-calculator',
    'calculate-fraction': 'fraction-calculator',
    'calculate-ratio': 'ratio-calculator',
    'calculate-mortgage': 'mortgage-calculator',
    'calculate-loan': 'loan-calculator',
    'calculate-autoloan': 'auto-loan-calculator',
    'calculate-refinance': 'refinance-calculator',
    'calculate-compoundinterest': 'compound-interest-calculator',
    'calculate-simpleinterest': 'simple-interest-calculator',
    'calculate-retirement': 'retirement-calculator',
    'calculate-401k': '401k-calculator',
    'calculate-savings': 'savings-calculator',
    'calculate-paycheck': 'paycheck-calculator',
    'calculate-salary': 'salary-calculator',
    'calculate-gpa': 'gpa-calculator',
    'calculate-grade': 'grade-calculator',
    'calculate-timecard': 'time-card-calculator',
    'calculate-hoursbetween': 'hours-between-calculator',
    'calculate-workingdays': 'working-days-calculator',
    'calculate-salestax': 'sales-tax-calculator',
    'calculate-vat': 'vat-calculator',
    'calculate-gst': 'gst-calculator',
    'calculate-sunrisesunset': 'sunrise-sunset-calculator',
    'calculate-tip': 'tip-calculator',
    'calculate-discount': 'discount-calculator',
    'calculate-cidr': 'cidr-calculator',
    'calculate-subnet': 'subnet-calculator',
    // S3 family #6 — ISO-8601 (only one xconvert-web-side piece)
    'validate-iso8601': 'iso-8601-validator',
    // S2 family #7 — random / fake data + crypto (FEATURE_EXPANSION_RESEARCH.md §5.7)
    'generate-nanoid': 'nanoid-generator',
    'generate-ulid': 'ulid-generator',
    'generate-ksuid': 'ksuid-generator',
    'generate-fakename': 'fake-name-generator',
    'generate-fakeemail': 'fake-email-generator',
    'generate-fakeaddress': 'fake-address-generator',
    'generate-fakephone': 'fake-phone-generator',
    'generate-randomip': 'random-ip',
    'generate-randomstring': 'random-string',
    'generate-randomnumber': 'random-number',
    'generate-randomcolor': 'random-color',
    'generate-mockjson': 'mock-json-generator',
    'generate-hmac': 'hmac-generator',
    'generate-bcrypt': 'bcrypt-generator',
    'generate-argon2': 'argon2-generator',
    'generate-scrypt': 'scrypt-generator',
    'encode-jwtsign': 'jwt-encoder',
    'decode-x509cert': 'x509-decoder',
    'convert-pem-to-der': 'convert-pem-to-der',
    'convert-der-to-pem': 'convert-der-to-pem',
    // S5 family #8 — font standalones (FEATURE_EXPANSION_RESEARCH.md §5.8)
    'generate-fontfacecss': 'font-face-css-generator',
    'generate-fontsubset': 'font-subsetter',
    // S6 family #10 — PDF page-ops (FEATURE_EXPANSION_RESEARCH.md §5.10)
    'addpagenumbers-pdf': 'add-page-numbers-pdf',
    'extractpages-pdf': 'extract-pdf-pages',
    'nup-pdf': 'n-up-pdf',
    'deletepages-pdf': 'delete-pages-pdf',
    // Edit PDF: the option path stays `edit-pdf` (that is `${processType}-${toExtension}`
    // and nothing else may name it), but the page is served at /pdf-editor — owner ruling 9,
    // 2026-09-03, recorded in xconvert-web/docs/proposed/pdf-editor-STATUS.md §3.0. This one
    // override is what moves the URL everywhere downstream: xconfig's feature-metadata
    // `urlPath`, the SSR route id, the sitemap entry and the mesh links all read it.
    'edit-pdf': 'pdf-editor',
};
// Canonical spelling per extension token. Direction rule: each pair
// canonicalizes to its HIGHER-DEMAND spelling — "jpg to png" query volume
// dwarfs "jpeg to png" (flipped 2026-08-10), while "tiff" dominates "tif"
// (unchanged). stp/igs entries are inert today (no stp-/igs- pages are
// generated) and kept only for future-proofing.
//
// Other same-format extension families were evaluated 2026-08-18 and
// deliberately NOT added — ts/mts/m2ts/avchd, mpeg/mpg/mpeg2, 3gp/3g2,
// aif/aiff/aifc, ogg/oga. They either carry independent search demand
// (mts alone: 2,861 source impressions) or produce genuinely different
// output here (.avchd needs renaming, .m2ts is not BDAV-framed, .mpeg2 is
// a misnamed program stream). Merging them would cost traffic and make the
// pages less accurate. Full analysis + numbers:
// xconvert-web/docs/research/seo/twin-extension-consolidation-2026-08-18.md
OptionPathToUrlMapper.canonicalUrlMapping = {
    "jpeg": "jpg",
    "tif": "tiff",
    "stp": "step",
    "igs": "iges"
};
OptionPathToUrlMapper.canonicalUrlKeySet = new Set(Object.keys(OptionPathToUrlMapper.canonicalUrlMapping));
// Slugs that stay self-canonical even though they contain a mapped token:
// compress-jpg is an nginx 301 to compress-jpeg, so mapping compress-jpeg
// would point its canonical through a redirect back to itself.
// (jpeg-converter is NOT excepted: it canonicalizes to the jpg-converter
// hub twin, which exists.)
OptionPathToUrlMapper.canonicalSlugExceptions = new Set([
    "compress-jpeg",
]);
